// extracted by mini-css-extract-plugin
export default {"main-section__4":"Section4_main-section__4__lFCfl"};